import i18n from 'i18next';

i18n.init({
  resources: {
    en: {},
  },
  lng: 'en',
  fallbackLng: 'en',
  debug: true,

  keySeparator: false, // we use content as keys

  interpolation: {
    escapeValue: false, // not needed for react!!
  },

  react: {
    useSuspense: true,
  },
});

export default i18n;
